import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalFunctions } from "../../core/global-functions";
import { CommonService } from "../../core/common.service";

@Injectable({
    providedIn: 'root'
})

export class LandingService {
    constructor(
        private _httpClient: HttpClient,
        private _globalFunctions: GlobalFunctions,
        private _commonService: CommonService
    ) { }

    getSubjects(data: any = {}): Observable<any> {
        return this._commonService.getSubjects(data);
    }

    getTutors(data: any): Observable<any> {
        const params = this._commonService.buildQueryParams(data);
        return this._httpClient.get('find-tutors', { params });
    }
    
    getTutorById(id: string):Observable<any>{
        return this._httpClient.get('find-tutors/' + id);
    }
}